/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJpmamV1DestinationState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JPMAM_V1_DESTINATION_STATE_ENTITY_NAME = 'exc.jpmam.v1.Destination';
export const excJpmamV1DestinationStateEntity = new schema.Entity<ExcJpmamV1DestinationState>(EXC_JPMAM_V1_DESTINATION_STATE_ENTITY_NAME, {}, { idAttribute: 'destinationId' });

